export enum RecurrenceCronType {
  EveryMonday = 'mon',
  EveryTuesday = 'tue',
  EveryWednesday = 'wed',
  EveryThursday = 'thu',
  EveryFriday = 'fri',
  EverySaturday = 'sat',
  EverySunday = 'sun',
}

export const weekdays = Object.values(RecurrenceCronType);

export const weekdayCronTypes = [
  RecurrenceCronType.EveryMonday,
  RecurrenceCronType.EveryTuesday,
  RecurrenceCronType.EveryWednesday,
  RecurrenceCronType.EveryThursday,
  RecurrenceCronType.EveryFriday,
] as const;

export const allWeekdayCronTypes = [
  ...weekdayCronTypes,
  RecurrenceCronType.EverySaturday,
  RecurrenceCronType.EverySunday,
] as const;

export enum OnTheWeekdayOrder {
  First = 'first',
  Second = 'second',
  Third = 'third',
  Fourth = 'fourth',
  Last = 'last',
}
